// Order recovery: small pill under the status text while a booking is being rescued.
// Finding provider → Assigning provider → Awaiting customer m:ss (offered, 1 s tick).
import React, { useEffect, useState } from 'react';
import './ReassignBadge.css';

const mmss = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

const ReassignBadge = ({ reassignment }) => {
    const state = reassignment?.state;
    const endsAt = Number(reassignment?.windowEndsAt || 0);
    const [, setTick] = useState(0);
    useEffect(() => {
        if (state !== 'offered' || !endsAt) return undefined;
        const id = setInterval(() => setTick((t) => t + 1), 1000);
        return () => clearInterval(id);
    }, [state, endsAt]);

    let cls = 'rb is-live';
    let text = 'Finding provider';
    let time = null;
    let title = 'Order recovery: searching for another provider';
    if (state === 'offered' && endsAt) {
        const left = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
        cls = `rb is-live ${left < 120 ? 'is-low' : 'is-info'}`;
        text = 'Customer pick';
        time = mmss(left);
        title = 'Order recovery: the customer is choosing a replacement';
    } else if (state === 'candidatesReady') {
        text = 'Assigning';
        title = 'Order recovery: assigning the best match';
    }
    return (
        <span className="rb-wrap">
            <span className={cls} title={title}>
                <span className="rb-line"><i className="rb-dot" />{text}</span>
                {time ? <span className="rb-time">{time}</span> : null}
            </span>
        </span>
    );
};

export default ReassignBadge;
